import { LightbulbSpotIcon } from './LightbulbSpotIcon';

/**
 * author: GreenTurtwig
 * id 2D6C2BB9-CF5E-4BD1-A44B-262F2A61FAC2
 * name lightbulb-spot
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-spot.svg
 * tags
 * - Home Automation 
 */
export const LightbulbHalogenIcon = LightbulbSpotIcon;
export default LightbulbHalogenIcon